module.exports = __webpack_public_path__ + "static/media/filter_7_white_18dp.342931d4.svg";